"use client"

import Link from "next/link"
import { ArrowRight, Calendar } from "lucide-react"
import { useTranslations } from "next-intl"

export function CTASection() {
  const t = useTranslations("cta")
  return (
    <section className="py-24 relative">
      <div className="relative rounded-3xl border border-accent-primary/20 bg-gradient-to-br from-accent-primary/5 via-background to-accent-secondary/5 p-8 md:p-12 lg:p-16 overflow-hidden">
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent-primary/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-secondary/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            {t("title")}
          </h2>
          
          <p className="text-muted-foreground text-lg mb-10 leading-relaxed">
            {t("subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/contact"
              className="group inline-flex items-center justify-center gap-2 rounded-lg bg-accent-primary px-8 py-4 text-base font-medium text-background transition-all hover:bg-accent-primary/90 hover:gap-3"
            >
              <Calendar className="h-5 w-5" />
              {t("scheduleConsultation")}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </div>

          {/* Trust indicators */}
          <div className="mt-12 pt-8 border-t border-border/50">
            <p className="text-muted-foreground/60 text-sm mb-4">{t("trustIndicator")}</p>
            <div className="flex flex-wrap justify-center gap-8 items-center opacity-50">
              <span className="text-muted-foreground font-medium">{t("methodology")}</span>
              <span className="w-1 h-1 rounded-full bg-muted-foreground" />
              <span className="text-muted-foreground font-medium">{t("focus")}</span>
              <span className="w-1 h-1 rounded-full bg-muted-foreground" />
              <span className="text-muted-foreground font-medium">{t("aiEnabled")}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
